import axios from 'axios';
const server = process.env.REACT_APP_SERVER;

async function getAlcanceFormulario({ regional }) {
    var result = await fetch(`${server}/formulario/getAlcancesFormularios`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            regional
        })
    })
    return result.json()
}

async function addContratacionEvaluacion(params) {
    var result = await fetch(`${server}/formulario/addContratacionEvaluacion`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}

async function getEvaluacionesColaborador(params) {
    var result = await fetch(`${server}/formulario/getEvaluacionesColaborador`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}

async function editarAlcanceFormulario(params) {
    var result = await fetch(`${server}/formulario/editarAlcanceFormulario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function getEvaluaciones(params) {
    var result = await fetch(`${server}/formulario/getFormularios`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function saveFormulario(params) {//{regional,idEncuesta,creadoPor,idEmpleado}
    var result = await fetch(`${server}/formulario/saveFormulario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function getFormulariosAsignados(params) {//{regional,idEmpleado}
    var result = await fetch(`${server}/formulario/getFormulariosAsignados`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function getRespuestaFormulario(params) {//regional,ID_FORMULARIO
    var result = await fetch(`${server}/formulario/getRespuestaFormulario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function guardarRespuestaFormulario(params) {//regional,ID_FORMULARIO,ID_RESPUESTA
    var result = await fetch(`${server}/formulario/agregarRespuestaFormulario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function obtenerRespuestasFormulario(params) {
    var result = await fetch(`${server}/formulario/obtenerRespuestasFormulario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function obtenerPreguntasFormulario(params) {
    var result = await fetch(`${server}/formulario/getPreguntas`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function eliminarFormulario(params) {
    var result = await fetch(`${server}/formulario/eliminarFormulario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function agregarDocumento(formData) {
    var result = await axios.post(`${server}/formulario/guardarDocumento`, formData, {
        'Accept': 'application/json',
        'content-type': 'multipart/form-data'
    })
    return result
}
async function obtenerAdjuntos(params) {
    var result = await fetch(`${server}/formulario/obtenerAdjuntos`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function eliminarAdjunto(params) {
    var result = await fetch(`${server}/formulario/eliminarAdjunto`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function getCuestionario(params) {
    var result = await fetch(`${server}/formulario/getCuestionario`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
async function eliminarColaboradorChat(params){
    var result = await fetch(`${server}/formulario/eliminarColaboradorChat`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...params
        })
    })
    return result.json()
}
export default {
    getAlcanceFormulario, addContratacionEvaluacion,
    getEvaluacionesColaborador, editarAlcanceFormulario,
    getEvaluaciones, saveFormulario, getFormulariosAsignados,
    getRespuestaFormulario, guardarRespuestaFormulario,
    obtenerRespuestasFormulario, obtenerPreguntasFormulario,
    eliminarFormulario, agregarDocumento, obtenerAdjuntos, eliminarAdjunto,
    getCuestionario,eliminarColaboradorChat
}